// Pure integer-unit scoring mirrors the versioned server policy; parity tested.
export function points(spec, correct, seconds) {
  const ms = Math.round(Math.max(0, Number(seconds) || 0) * 1000);
  if (!correct || ms > spec.timeout_seconds * 1000) return 0;
  return (spec.base * (spec.bonus_end_ms-spec.grace_ms) + spec.bonus * Math.max(0, Math.min(spec.bonus_end_ms-spec.grace_ms, spec.bonus_end_ms-ms))) / (spec.bonus_end_ms-spec.grace_ms);
}
export function average(values) {
  return values.length ? values.reduce((a,v)=>a+Math.min(100,Math.max(0,Number(v)||0)),0)/values.length : 0;
}
